import {
  withTranslation,
} from 'react-i18next';

import RegattaResultTablesSectionView from './RegattaResultTablesSectionView';
import './RegattaResultTablesSection.css';

const TranslatedComponent = withTranslation()(RegattaResultTablesSectionView);

const Component = TranslatedComponent;

export default Component;
